"use client"

import { useState } from "react"
import { Col, Container, Row } from "reactstrap"
import Breadcrumbs from "../../../CommonElements/Breadcrumbs/Breadcrumbs"
import OrderVerificationList from "./OrderVerificationList"
import OrderDetailsModal from "./OrderDetailsModal"
import type { PrintOrder } from "../BadgeRequest/badge-request"

const OrderVerificationContainer = () => {
  const [selectedOrder, setSelectedOrder] = useState<PrintOrder | null>(null)
  const [modalOpen, setModalOpen] = useState(false)
  const [refreshTrigger, setRefreshTrigger] = useState(false)

  const handleViewOrder = (order: PrintOrder) => {
    setSelectedOrder(order)
    setModalOpen(true)
  }

  const handleOrderAction = () => {
    setModalOpen(false)
    setSelectedOrder(null)
    setRefreshTrigger((prev) => !prev)
  }

  return (
    <>
      <Breadcrumbs mainTitle="Order Verification" parent="Badge Management" />
      <Container fluid>
        <Row>
          <Col md="12">
            <OrderVerificationList onViewOrder={handleViewOrder} refresh={refreshTrigger} />
          </Col>
        </Row>

        {modalOpen && selectedOrder && (
          <OrderDetailsModal
            isOpen={modalOpen}
            toggle={() => setModalOpen(false)}
            order={selectedOrder}
            onOrderAction={handleOrderAction}
          />
        )}
      </Container>
    </>
  )
}

export default OrderVerificationContainer
